import mixpanel from "mixpanel-browser";

import { InitProps, TrackerMixpanel } from "./TrackerMixpanel";

export class TrackerMixpanelReplays extends TrackerMixpanel {
  protected mixpanel: typeof mixpanel;

  constructor() {
    super();
    this.mixpanel = mixpanel;
  }

  initialize({ propertyId, debug, apiHost, cookieDomain }: InitProps) {
    super.initialize({ propertyId, debug, apiHost, cookieDomain });
  }

  startSessionRecording() {
    if (!this.enabled) return;
    const isRecording = !!this.getSessionRecordingId();
    if (!isRecording) {
      this.mixpanel.start_session_recording();
    }
  }

  stopSessionRecording() {
    if (!this.enabled) return;
    const isRecording = !!this.getSessionRecordingId();
    if (isRecording) {
      this.mixpanel.stop_session_recording();
    }
  }

  getSessionRecordingId(): string | null {
    if (!this.enabled) return null;
    const properties = this.mixpanel.get_session_recording_properties();
    return "$mp_replay_id" in properties && properties.$mp_replay_id
      ? properties.$mp_replay_id
      : null;
  }
}

const trackerReplays = new TrackerMixpanelReplays();

export default trackerReplays;
